import config from "src/config"

export const IMAGE_URL_PREFIX = `${config().client.cdnAssetPrefix}/images`
export const LOTTIE_URL_PREFIX = `${config().client.cdnAssetPrefix}/lottie`
